import styled from "styled-components";

export const InputError = styled.p`
  color: #d32f2f;
  text-align: left;
  margin-bottom: 0;
`